import { RootState } from 'src/store/store';

// Export selectors
export const selectPaymentID = (state: RootState) => state.payment.paymentID;
export const selectPaymentSignatory = (state: RootState) =>
  state.payment.signatoryName;
export const selectPaymentFees = (state: RootState) =>
  state.payment.paymentFees;
export const selectSelectedPaymentMethod = (state: RootState) =>
  state.payment.selectedPaymentMethod;
export const selectPaymentSuccessInfo = (state: RootState) =>
  state.payment.paymentSuccesInfo;
export const selectPaymentCheckFailed = (state: RootState) =>
  state.payment.paymentCheckFailed;
